import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaPhone,          // v6 replacement for FaPhoneAlt
  FaEnvelope,
  FaGlobe,
  FaLocationDot,    // v6 replacement for FaMapMarkerAlt
  FaLinkedinIn,
  FaXTwitter,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa6";
import "./Footer.css";

export default function Footer() {
  const [subscribed, setSubscribed] = useState(false);
  const year = new Date().getFullYear();

  const socials = [
    { key: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/nexite", Icon: FaLinkedinIn },
    { key: "x", label: "X (Twitter)", href: "https://twitter.com", Icon: FaXTwitter },
    { key: "facebook", label: "Facebook", href: "https://facebook.com", Icon: FaFacebookF },
    { key: "instagram", label: "Instagram", href: "https://instagram.com", Icon: FaInstagram },
    { key: "youtube", label: "YouTube", href: "https://youtube.com", Icon: FaYoutube },
  ];

  const quickLinks = [
    { to: "/about", label: "About" },
    { to: "/services", label: "Services" },
    { to: "/resources", label: "Resources" },
    { to: "/contact", label: "Contact" },
  ];

  const services = [
    { to: "/security", label: "Security" },
    { to: "/network", label: "Network" },
    { to: "/it-infrastructure", label: "IT Infrastructure" },
    { to: "/general-order-supply", label: "General Order Supply" },
  ];

  function onSubscribe(e) {
    e.preventDefault();
    const email = new FormData(e.currentTarget).get("email");
    if (email) {
      setSubscribed(true);
      setTimeout(() => setSubscribed(false), 5000);
      e.currentTarget.reset();
    }
  }

  return (
    <footer className="site-footer" aria-labelledby="footer-heading">
      <div className="ft-bg" aria-hidden="true">
        <span className="ft-blob b1" />
        <span className="ft-blob b2" />
        <span className="ft-blob b3" />
        <span className="ft-grid-glow" />
      </div>

      <div className="ft-container">
        <div className="ft-top">
          <div className="ft-brand">
            <div className="ft-logo-row">
              <div className="ft-logo">N</div>
              <h2 id="footer-heading" className="ft-name">Nexite</h2>
            </div>
            <p className="ft-tagline">Building digital solutions that make a difference.</p>

            <div className="ft-socials" role="list" aria-label="Social media">
              {socials.map(({ key, label, href, Icon }) => (
                <a
                  key={key}
                  className="ft-social"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div className="ft-newsletter">
            <h3 className="ft-subtitle">Join our newsletter</h3>
            <p className="ft-note">Be first to know about case studies, releases, and news.</p>

            {subscribed && (
              <div className="ft-alert success" role="status">
                <span className="ft-dot">✓</span>
                <div>
                  <strong>Subscribed.</strong> Thank you for joining us!
                </div>
              </div>
            )}

            <form className="ft-form" onSubmit={onSubscribe}>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                aria-label="Email address"
                required
              />
              <button type="submit" className="ft-btn ft-btn-primary">
                <span className="shine" aria-hidden="true" />
                Subscribe
              </button>
            </form>
            <p className="ft-legal">By subscribing you agree to our <Link to="/privacy">Privacy Policy</Link>.</p>
          </div>
        </div>

        <div className="ft-grid">
          <nav className="ft-col" aria-label="Quick links">
            <h4>Explore</h4>
            <ul>
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="ft-col" aria-label="Services">
            <h4>Services</h4>
            <ul>
              {services.map((s) => (
                <li key={s.to}>
                  <Link to={s.to}>{s.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="ft-col" aria-label="Contact">
            <h4>Contact</h4>
            <ul className="ft-contact">
              <li>
                <FaPhone className="ft-ico" />
                <a href="tel:+923235522788">+92 323 5522788</a>
              </li>
              <li>
                <FaEnvelope className="ft-ico" />
                <a href="mailto:info.nexite@gmail.com">info.nexite@gmail.com</a>
              </li>
              <li>
                <FaGlobe className="ft-ico" />
                <a href="https://nexite.com.pk" target="_blank" rel="noopener noreferrer">nexite.com.pk</a>
              </li>
              <li>
                <FaLocationDot className="ft-ico" />
                <a
                  href="https://maps.google.com/?q=Gulberg Greens, Islamabad"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gulberg Greens, Islamabad
                </a>
              </li>
            </ul>
          </div>

          <div className="ft-col ft-card" aria-hidden="true">
            <div className="ft-minimap">
              <div className="ft-minimap-title">Our Location</div>
              <p>Islamabad · Pakistan</p>
              <a
                className="ft-btn ft-btn-secondary"
                href="https://maps.google.com/?q=Gulberg Greens, Islamabad"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open in Maps
              </a>
              <span className="card-shine" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>

      <div className="ft-bottom">
        <div className="ft-container ft-bottom-row">
          <p>© {year} Nexite. All rights reserved.</p>
          <div className="ft-legal-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
        <div className="ft-accent" aria-hidden="true" />
      </div>
    </footer>
  );
}